export default class LaneConfig {
    
    constructor(color, shape, speed) {
        this._color = color;
        this._shape = shape;
        this._speed = speed;
    }
    
    /**@type {string} Id of color*/
    get color() {
        return this._color;
    }
    
    /**@type {string} Id of shape*/
    get shape() {
        return this._shape;
    }
    
    /**@type {Number} Index of speed*/
    get speed() {
        return this._speed;
    }
};
